/** What the right drawer shows, as encoded in the URL (deep-linkable). */
export type SelectionKind = 'building' | 'player' | 'giver' | 'police' | 'roamer'

export interface Selection {
  kind: SelectionKind
  id: string
}

const NPC_KINDS = ['giver', 'police', 'roamer'] as const

/** ?building=<id> · ?player=<id> · ?npc=<giver|police|roamer>:<id> */
export function parseSelection(params: URLSearchParams): Selection | null {
  const building = params.get('building')
  if (building) return { kind: 'building', id: building }
  const player = params.get('player')
  if (player) return { kind: 'player', id: player }
  const npc = params.get('npc')
  if (npc) {
    const i = npc.indexOf(':')
    if (i > 0) {
      const kind = npc.slice(0, i)
      const id = npc.slice(i + 1)
      if (id && (NPC_KINDS as readonly string[]).includes(kind)) return { kind: kind as SelectionKind, id }
    }
  }
  return null
}

export function withSelection(params: URLSearchParams, sel: Selection | null): URLSearchParams {
  const next = new URLSearchParams(params)
  next.delete('building')
  next.delete('player')
  next.delete('npc')
  if (sel) {
    if (sel.kind === 'building') next.set('building', sel.id)
    else if (sel.kind === 'player') next.set('player', sel.id)
    else next.set('npc', `${sel.kind}:${sel.id}`)
  }
  return next
}

export function selectionHref(sel: Selection): string {
  return `/map?${withSelection(new URLSearchParams(), sel).toString()}`
}
